function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _this9 = this;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sortable from 'sortablejs';
import manageRange from '@/components/form-common/select-manageRange';
import { getProgramSelectApi, getProgramTaskApi, getProgramVersionSelectApi, putProgramTaskApi, putTaskSortApi } from '@/api/program';
import SettingMer from '@/libs/settingMer';
export default {
  name: 'TableData',
  components: {
    manageRange: manageRange
  },
  props: {
    headerShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    projectList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programId: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tableData: [],
      loading: false,
      expandedKeys: [],
      iconVisible: {},
      adminsVisible: {},
      membersVisible: {},
      showStartTime: '',
      showEndTime: '',
      showVersion: '',
      versionList: {},
      endShowStates: {},
      selectData: {
        priorityOptions: [{
          value: 1,
          label: '紧急'
        }, {
          value: 2,
          label: '高'
        }, {
          value: 3,
          label: '中'
        }, {
          value: 4,
          label: '低'
        }, {
          value: 0,
          label: '无优先级'
        }],
        statusOptions: [{
          value: 0,
          label: '未处理'
        }, {
          value: 1,
          label: '进行中'
        }, {
          value: 2,
          label: '已解决'
        }, {
          value: 3,
          label: '已验收'
        }, {
          value: 4,
          label: '已拒绝'
        }]
      },
      total: 0,
      memberShow: false,
      timeVal: [],
      tableFrom: {
        page: 1,
        limit: 15,
        types: 0,
        pid: 0,
        status: '',
        name: '',
        admins: [],
        scope_frame: 'all',
        time_field: 'plan_start',
        scope_normal: 0,
        program_id: this.$route.query.id || [],
        version_id: [],
        eid: [],
        cid: []
      },
      showText: '展开',
      showForm: false,
      typesOptions: [{
        value: 0,
        label: '全部任务'
      }, {
        value: 1,
        label: '我负责的'
      }, {
        value: 2,
        label: '我参与的'
      }, {
        value: 3,
        label: '我创建的'
      }],
      statusOptions: [{
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '进行中'
      }, {
        value: 2,
        label: '已解决'
      }, {
        value: 3,
        label: '已验收'
      }, {
        value: 4,
        label: '已拒绝'
      }],
      timeOptions: [{
        value: 'plan_start',
        label: '计划开始'
      }, {
        value: 'plan_end',
        label: '计划结束'
      }, {
        value: 'created_at',
        label: '创建时间'
      }],
      type: 0,
      userList: [],
      helperList: [],
      versionVisible: {}
    };
  },
  created: function created() {
    this.getTableData();
    // this.getProgram()
  },
  mounted: function mounted() {
    var _this = this;
    var tbody = document.querySelector('.el-table__body-wrapper tbody');
    new Sortable(tbody, {
      animation: 150,
      fallbackOnBody: true,
      swapThreshold: 0.65,
      onMove: function onMove(_ref) {
        var dragged = _ref.dragged,
          related = _ref.related;
        var oldRow = _this.activeRows[dragged.rowIndex]; // 移动的那个元素
        var newRow = _this.activeRows[related.rowIndex]; // 新的元素
        _this.childrenNewPid = newRow.pid;
        _this.childrenOldPid = oldRow.pid;
        _this.childrenLevel = newRow.level;
        if (_this.childrenNewPid !== _this.childrenOldPid) {
          return false;
        }
        var ids = _this.activeIds;
        var _ref2 = [ids[related.rowIndex], ids[dragged.rowIndex]];
        ids[dragged.rowIndex] = _ref2[0];
        ids[related.rowIndex] = _ref2[1];
        if (newRow.pid && oldRow.pid == newRow.pid) {}
      },
      onStart: function onStart() {
        _this.activeRows.map(function (item) {
          _this.activeIds.push(item.id);
        });
      }
    });
  },
  watch: {
    projectList: function projectList(newVal) {
      this.projectList = newVal;
    }
  },
  methods: {
    addChild: function addChild(parentId) {
      var _this2 = this;
      this.parentId = parentId;
      this.addName = '';
      var newRow = {
        id: Date.now(),
        name: '',
        children: [],
        add: true
      };
      var _findAndAdd = function findAndAdd(array) {
        array.forEach(function (item) {
          if (item.id === parentId) {
            if (!item.children) {
              _this2.$set(item, 'children', []);
            }
            item.children.push(newRow);
            _this2.$set(item, 'has_children', true);
            _this2.$nextTick(function () {
              _this2.focusOnNewRow(newRow.id);
            });
          } else if (item.children && item.children.length > 0) {
            _findAndAdd(item.children);
          }
        });
      };
      _findAndAdd(this.tableData);
    },
    focusOnNewRow: function focusOnNewRow(id) {
      var _this3 = this;
      this.$nextTick(function () {
        var element = _this3.$refs["edit-".concat(id)];
        if (element && element[0]) {
          element[0].focus();
          element[0].addEventListener('keyup', function (event) {
            if (event.key === 'Enter') {
              _this3.submitNewRow(id);
            }
          });
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedId = val.map(function (item) {
        return item.id;
      });
      this.ids = val;
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data, _res, _this4$maps$get, tree, treeNode, resolve, _this4$maps$get2, _tree, _treeNode, _resolve;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.loading = true;
              _context.next = 3;
              return getProgramTaskApi(_this4.tableFrom);
            case 3:
              res = _context.sent;
              _this4.loading = false;
              _this4.tableData = res.data.list;
              return _context.abrupt("return");
            case 12:
              _res = _context.sent;
              _this4.tableData = _res.data.list;
              _this4.tableList = _res.data.list;
              if (data.pid) {
                _this4.tableChildrenData = _res.data.list;
              }
              _this4.activeRows = _toConsumableArray(_this4.tableData);
              _this4.total = _res.data.count;
              _this4.loading = false;
            case 19:
              if (_this4.parentRoleId && _this4.maps.get(_this4.parentRoleId)) {
                _this4.loading = false;
                _this4$maps$get = _this4.maps.get(_this4.parentRoleId), tree = _this4$maps$get.tree, treeNode = _this4$maps$get.treeNode, resolve = _this4$maps$get.resolve;
                _this4.load(tree, treeNode, resolve);
              }
              //懒加载刷新当前级
              if (_this4.currentRoleId && _this4.maps.get(_this4.currentRoleId)) {
                _this4.loading = false;
                _this4$maps$get2 = _this4.maps.get(_this4.currentRoleId), _tree = _this4$maps$get2.tree, _treeNode = _this4$maps$get2.treeNode, _resolve = _this4$maps$get2.resolve;
                _this4.load(_tree, _treeNode, _resolve);
              }
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取项目数据
    getProgram: function getProgram() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getProgramSelectApi();
            case 2:
              result = _context2.sent;
              _this5.projectList = result.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取项目版本数据
    getProgramVersion: function getProgramVersion(program_id, index, type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getProgramVersionSelectApi({
                program_id: program_id
              });
            case 2:
              result = _context3.sent;
              _this6.versionList = result.data;
              if (_this6.versionList.length) {
                _this6.$set(_this6.versionVisible, index, true);
              } else if (type == 1) {
                _this6.$message('请到任务详情设置版本');
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    chooseVersion: function chooseVersion(row, index) {
      this.putProgramTask('version_id', this.versionId, row.id);
      this.hideVersion(index);
    },
    setParamId: function setParamId(param, id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.$set(_this7, param, id);
              if (!(param === 'showVersion')) {
                _context4.next = 4;
                break;
              }
              _context4.next = 4;
              return _this7.getProgramVersion(id);
            case 4:
              if (_this7.$refs[param + id]) {
                _this7.$nextTick(function () {
                  _this7.$refs[param + id].focus();
                });
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    clearParamId: function clearParamId(param) {
      if (param) {
        this.$set(this, param, '');
      } else {
        this.$set(this, 'showStartTime', '');
        this.$set(this, 'showEndTime', '');
        this.$set(this, 'showVersion', '');
      }
    },
    changeParam: function changeParam(key, row) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this8.putProgramTask(key, row.version.id, row.id);
              _context5.next = 3;
              return _this8.clearParamId();
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 修改
    putProgramTask: function putProgramTask(field, data, id) {
      var datas = {};
      datas['field'] = field;
      datas[field] = data;
      if (field == 'pid') {
        datas['path'] = this.formData.path;
      }
      var res = putProgramTaskApi(id, datas);
      if (res.status === 200) {
        this.getTableData();
        this.preventBlur = true;
        this.$set(this.membersVisible, this.membersIndex, false);
      }
    },
    // 拖拽结束
    onEnd: function onEnd(_ref3) {
      var newIndex = _ref3.newIndex,
        oldIndex = _ref3.oldIndex;
      _this9.activeRows.map(function (item) {
        if (item.id === _this9.childrenNewPid) {
          _this9.childrenTotal = item.children_count;
        }
      });
      if (_this9.childrenNewPid) {
        var pidIndex = _this9.activeIds.indexOf(_this9.childrenNewPid);
        _this9.activeIds = _this9.activeIds.slice(pidIndex + 1, pidIndex + 1 + _this9.childrenTotal);
      }
      if (_this9.childrenNewPid !== _this9.childrenOldPid) {
        _this9.activeIds = [];
        _this9.childrenNewPid = 0;
        _this9.childrenTotal = 0;
        _this9.$message.warning('不允许跨级拖动!');
        return false;
      }
      var filteredRows = _this9.activeRows.filter(function (row) {
        return row.level === _this9.childrenLevel;
      });
      _this9.activeIds = _this9.activeIds.map(function (id) {
        return filteredRows.find(function (row) {
          return row.id === id;
        });
      }).filter(function (row) {
        return row !== undefined;
      }) // 移除未找到匹配项的情况
      .map(function (row) {
        return row.id;
      });
      if (!_this9.activeIds) return false;
      putTaskSortApi({
        data: _this9.activeIds
      }).then(function () {
        _this9.tableFrom.pid = 0;
        _this9.getTableData();
        _this9.activeRows = [];
        _this9.activeIds = [];
        _this9.tableData = [];
        _this9.childrenNewPid = 0;
        _this9.childrenTotal = 0;
        _this9.expandedKeys = [];
      });
    },
    // 复制工作项地址
    identAddress: function identAddress(row) {
      var type = 'type',
        relation_id = 'relation_id',
        program_id = 'program_id';
      return "".concat(SettingMer.httpUrl).concat(window.location.pathname).concat(window.location.search, "?&").concat(type, "=2&").concat(relation_id, "=").concat(row.id, "&").concat(program_id, "=").concat(row.program_id);
    },
    // 复制工作项地址
    copy: function copy(row) {
      var type = 'type',
        relation_id = 'relation_id',
        program_id = 'program_id';
      return "".concat(SettingMer.httpUrl).concat(window.location.pathname).concat(window.location.search, "?&").concat(type, "=2&").concat(relation_id, "=").concat(row.id, "&").concat(program_id, "=").concat(row.program_id);
    }
  }
};